import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=42515f40&"
import script from "./MenuModal.vue?vue&type=script&lang=ts&"
export * from "./MenuModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports